var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackInterview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25001 2C6.94037 2 7.50002 2.55965 7.50002 3.25V4.50001H8.75002C9.44038 4.50001 10 5.05965 10 5.75001C10 6.44037 9.44038 7.00002 8.75002 7.00002H7.50002V8.25002C7.50002 8.94038 6.94037 9.50002 6.25001 9.50002C5.55965 9.50002 5.00001 8.94038 5.00001 8.25002V7.00002H3.75C3.05965 7.00002 2.5 6.44037 2.5 5.75001C2.5 5.05965 3.05965 4.50001 3.75 4.50001H5.00001V3.25C5.00001 2.55965 5.55965 2 6.25001 2ZM6.25001 14.5C6.94037 14.5 7.50002 15.0597 7.50002 15.75V17H8.75002C9.44038 17 10 17.5597 10 18.25C10 18.9404 9.44038 19.5001 8.75002 19.5001H7.50002V20.7501C7.50002 21.4404 6.94037 22.0001 6.25001 22.0001C5.55965 22.0001 5.00001 21.4404 5.00001 20.7501V19.5001H3.75C3.05965 19.5001 2.5 18.9404 2.5 18.25C2.5 17.5597 3.05965 17 3.75 17H5.00001V15.75C5.00001 15.0597 5.55965 14.5 6.25001 14.5Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2C15.5671 2 16.0632 2.38185 16.2084 2.93014L17.6824 8.49868L21.8747 10.9173C22.2616 11.1405 22.5 11.5533 22.5 12C22.5 12.4468 22.2616 12.8595 21.8747 13.0828L17.6824 15.5014L16.2084 21.0699C16.0632 21.6182 15.5671 22.0001 15 22.0001C14.4328 22.0001 13.9367 21.6182 13.7916 21.0699L12.3176 15.5014L8.12536 13.0828C7.73841 12.8595 7.50002 12.4468 7.50002 12C7.50002 11.5533 7.73841 11.1405 8.12536 10.9173L12.3176 8.49869L13.7916 2.93014C13.9367 2.38185 14.4328 2 15 2Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInterview);
export default __webpack_public_path__ + "static/media/black-interview.82985a6b71714329be2c90484e924ed8.svg";
export { ForwardRef as ReactComponent };